import React from 'react';
import { Box, Button, Layer, Text } from 'grommet';

const Modal = (props) => { 

    const { children, borderColor, closerColor, onClose } = props

    const CloserLabel = () => (
        <Box>
            <Text color={closerColor} weight='bold'>X</Text>
        </Box>
    )    

    return(
        <Layer  
            border={{ color: borderColor, size: 'large' }} 
            onClickOutside={onClose}
            position='center' 
        >
            <Box  
                border={{ color: borderColor, size: 'large' }}
            >
                <Box 
                    alignSelf='end'
                    direction='row' 
                    gap='medium'
                    pad={{ right: 'medium', top: 'medium'}} 
                >
                    <Button label={<CloserLabel />} onClick={onClose} plain={true} />
                </Box>
                <Box
                  pad={{ bottom: 'medium', horizontal: 'medium'}}
                >
                  {children}
                </Box>
            </Box>  
        </Layer>
    )
}

export default Modal